import axiosInstance from "./axiosInstance";

export const registerUser = async (userData) => {
  const res = await axiosInstance.post("accounts/register/", userData);
  return res.data;
};

export const loginUser = async (credentials) => {
  const res = await axiosInstance.post("accounts/token/", credentials);
  localStorage.setItem("access_token", res.data.access);
  localStorage.setItem("refresh_token", res.data.refresh);
  return res.data;
};

export const getCurrentUser = async () => {
  const res = await axiosInstance.get("accounts/me/");
  return res.data;
};

export const verifyEmail = async (email, code) => {
  const res = await axiosInstance.post("accounts/verify-email/", { email, code });
  return res.data;
};

export const resendCode = async (email) => {
  const res = await axiosInstance.post("accounts/resend-code/", { email });
  return res.data;
};

export const forgotPassword = async (email) => {
  const res = await axiosInstance.post("accounts/forgot-password/", { email });
  return res.data;
};

export const resetPassword = async (email, code, new_password) => {
  const res = await axiosInstance.post("accounts/reset-password/", { email, code, new_password });
  return res.data;
};

export const logoutUser = async () => {
  try {
    const refresh = localStorage.getItem("refresh_token");
    if (refresh) {
      await axiosInstance.post("accounts/logout/", { refresh });
    }
  } catch (error) {
    console.error("Logout API error:", error);
  } finally {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }
};
